const consumer = [
  {
    label: 'Messages',
    isRoute: true,
    name: 'consumer::inbox',
  },
  {
    label: 'Account Info',
    isRoute: true,
    name: 'account::info',
  },
  {
    label: 'My Requests',
    isRoute: true,
    name: 'consumer::dashboard',
  },
  {
    label: 'Logout',
    isRoute: true,
    name: 'logout',
    icon: true,
  },

];

export default {
  consumer,
};
